import React, { Component } from 'react';
import Loader from '../components/Loader';
import { AuthLogic } from '../auth/AuthLogic';

class Logout extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        AuthLogic.getInstance().logout();
    }

    render() {
        return <Loader />;
    }
}

export default Logout;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Logout.tsx